import {
  Box,
  BoxProps,
  Grid,
  Heading,
  OptionTile,
  smBumps,
  xsBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { CoverLevelOption } from '../../../../domain'
import {
  TKeyBuilder,
  tProduct,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { PaymentScheduleType } from '../../../../state/configuration'

export interface PaymentScheduleProps extends BoxProps {
  tKey: TKeyBuilder
  value?: PaymentScheduleType
  onChange: (value: PaymentScheduleType) => void
  coverOptions: CoverLevelOption[]
}

const key = 'payment-schedule'

export const PaymentScheduleSelection: FunctionComponent<PaymentScheduleProps> = ({
  tKey,
  value,
  onChange,
  coverOptions,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const header = t(tKey(key, 'header'), { defaultValue: null })

  return coverOptions.length > 1 ? (
    <Box display='flex' flexDirection='column' gap={smBumps} width={1} {...props}>
      {header && (
        <Heading variant='h4' as='h4' typoSize='md'>
          {header}
        </Heading>
      )}
      <Grid
        gridTemplateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)']}
        width={1}
        gap={xsBumps}
      >
        {coverOptions.map((it) => (
          <OptionTile
            key={it.paymentScheduleType}
            name={key}
            value={it.paymentScheduleType}
            text={t(tProduct('payment-schedules', it.paymentScheduleType))}
            onSelect={onChange}
            checked={value === it.paymentScheduleType}
          />
        ))}
      </Grid>
    </Box>
  ) : null
}
